__turbopack_context__.v({
  "divider": "mvlo0q_divider",
  "footnote": "mvlo0q_footnote",
  "footnoteScience": "mvlo0q_footnoteScience",
  "label": "mvlo0q_label",
  "num": "mvlo0q_num",
  "numGhost": "mvlo0q_numGhost",
  "row": "mvlo0q_row",
  "section": "mvlo0q_section",
  "stat": "mvlo0q_stat",
  "value": "mvlo0q_value",
});
